import { Injectable, signal } from '@angular/core';

import { isCrawler, syncWithLocalStorage } from '../helpers';

@Injectable({
  providedIn: 'root'
})
export class SettingsState {
  public readonly disableAnimations = signal<boolean>(false);
  public readonly stickersEnabled = signal<boolean>(true);
  public readonly streamerMode = signal<boolean>(false);
  public readonly firstRun = signal<boolean>(true);
  public readonly optimize = signal<boolean>(false);
  public readonly crashTwoBets = signal<boolean>(false);
  public readonly isStretchDesign = signal<boolean>(false);
  public readonly isVer2 = signal<boolean>(false);

  private readonly localStorageEffect = syncWithLocalStorage('settings', {
    disableAnimations: this.disableAnimations,
    stickersEnabled: this.stickersEnabled,
    streamerMode: this.streamerMode,
    firstRun: this.firstRun,
    crashTwoBets: this.crashTwoBets,
    optimize: this.optimize,
    isStretchDesign: this.isStretchDesign,
    isVer2: this.isVer2
  });

  constructor() {
    if (!this.isVer2()) {
      this.disableAnimations.set(false);
      this.isVer2.set(true);
    }

    if(this.firstRun()) {
      this.loadOptimizedDefaults();
    }

    if(!this.optimize()) {
      this.optimize.set(true);
      this.loadOptimizedDefaults();
    }
  }

  toggleCrashTwoBets(): void {
    this.crashTwoBets.update(value => !value);
  }

  toggleDisableAnimations(): void {
    this.disableAnimations.update(value => !value);
  }

  toggleStretchDesign(): void {
    this.isStretchDesign.update(value => !value);
  }

  toggleStickersEnabled(): void {
    this.stickersEnabled.update(value => !value);
  }

  toggleStreamerMode(): void {
    this.streamerMode.update(value => !value);
  }

  private loadOptimizedDefaults(): void {
    if(isCrawler) {
      this.disableAnimations.set(true);
      this.stickersEnabled.set(false);
    }

    this.firstRun.set(false);
  }
}